// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1sYDr","col":"styles_col__WphQb"};